import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import {
  movimientoTramiteAddFailure,
  movimientoTramiteAddRequest,
  movimientoTramiteAddSuccess,
  movimientoTramiteLoadRequest,
  movimientoTramiteLoadSuccess
} from './movimiento-tramite.actions';

import { MovimientoTramiteService } from './movimiento-tramite.service';

@Injectable()
export class MovimientoTramiteEffects {
  // add
  addRequestMovimientoTramite = createEffect(() =>
    this.actions$.pipe(
      ofType(movimientoTramiteAddRequest),
      switchMap((action) =>
        this.movimientoTramiteService.addMovimientoTramite(action.item).pipe(
          map((item) => movimientoTramiteAddSuccess({ item })),
          catchError((error) => of(movimientoTramiteAddFailure({ error })))
        )
      )
    )
  );

  movimientoTramiteLoadRequest = createEffect(() =>
    this.actions$.pipe(
      ofType(movimientoTramiteLoadRequest),
      switchMap(() =>
        this.movimientoTramiteService.loadMovimientoTramite().pipe(
          map((item) => movimientoTramiteLoadSuccess({ items: item })),
          catchError((error) => of(movimientoTramiteAddFailure({ error })))
        )
      )
    )
  );

  addSuccessMovimientoTramite = createEffect(
    () =>
      this.actions$.pipe(
        ofType(movimientoTramiteAddSuccess),
        tap(() => {
          // this.alertService.success('Tramite registrado con éxito')
          this.router.navigateByUrl('/tramite/vista-tramites');
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private movimientoTramiteService: MovimientoTramiteService,
    private router: Router
  ) {
    this.movimientoTramiteService.url = environment.apiUrl;
  }
}
